// Authentication utility functions

// Check if user is authenticated
export const isAuthenticated = () => {
  const token = localStorage.getItem('auth_token');
  return !!token;
};

// Get admin name from localStorage
export const getAdminName = () => {
  // Try to get from user_data first (name field), then fallback to admin_name
  try {
    const userData = localStorage.getItem('user_data');
    if (userData) {
      const user = JSON.parse(userData);
      if (user.name) {
        return user.name;
      }
    }
  } catch (error) {
    console.error('Error parsing user data:', error);
  }
  
  return localStorage.getItem('admin_name') || '';
};

// Get user data from localStorage
export const getUserData = () => {
  try {
    const userData = localStorage.getItem('user_data');
    return userData ? JSON.parse(userData) : null;
  } catch (error) {
    console.error('Error parsing user data:', error);
    return null;
  }
};

// Redirect to dashboard if authenticated
export const redirectIfAuthenticated = () => {
  if (isAuthenticated()) {
    window.location.href = '#/admin/dashboard';
    return true;
  }
  return false;
};

// Redirect to signin if not authenticated
export const redirectIfNotAuthenticated = () => {
  if (!isAuthenticated()) {
    window.location.href = '#/auth/signin';
    return true;
  }
  return false;
};

// Clear all authentication data
export const clearAuthData = () => {
  localStorage.removeItem('auth_token');
  localStorage.removeItem('admin_name');
  localStorage.removeItem('user_data');
};
